<template lang="html">
  <h1 class="baseh1--text">Üdvözöllek a soroban gyakorlóban!</h1>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
h1{
  text-align: center;
  font-size: 2rem;
  font-weight: 500;
}
</style>
